import React from 'react';

const MemberCard = ({ image, name, position }) => {
    return (
        <div className="member-card bg-[#2d3748] rounded-xl p-6 text-center shadow-md">
            <img
                src={image}
                alt={`${name}'s profile picture`}
                className="w-24 h-24 object-cover rounded-full mx-auto mb-4 border-4 border-red-600"
            />
            <h3 className="text-lg font-semibold text-white">{name}</h3>
            <p className="text-gray-400 text-sm">{position}</p>
        </div>
    );
};

export default MemberCard;